import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, MapPin, Phone } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative bg-white overflow-hidden">
      {/* Hero Content */}
      <div className="max-w-7xl mx-auto">
        <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:w-full lg:pb-28 xl:pb-32">
          {/* Navigation */}
          <nav className="relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_prime-detail-service/artifacts/2no31ay6_Prime%20Detailing%20mascot%20logo.png" 
                alt="Prime Detail Logo" 
                className="h-16 w-auto"
              />
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a href="#services" className="text-gray-700 hover:text-green-600 transition-colors font-medium">
                Services
              </a>
              <a href="#contact-form" className="text-gray-700 hover:text-green-600 transition-colors font-medium">
                Contact
              </a>
              <Button 
                onClick={scrollToContact}
                className="bg-green-600 hover:bg-green-700 text-white shadow-lg hover:shadow-xl transition-all"
              >
                Free Estimate
              </Button>
            </div>
          </nav>

          {/* Hero Main Content */}
          <main className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center px-4 py-2 bg-green-50 rounded-full mb-6">
                <MapPin className="w-4 h-4 text-green-600 mr-2" />
                <span className="text-sm font-medium text-gray-700">
                  Mobile Service • {businessInfo.serviceRadius} from {businessInfo.location}
                </span>
              </div>
              
              <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                <span className="block">Premium Auto Detailing</span>
                <span className="block text-green-600 mt-2">We Come To You</span>
              </h1>
              
              <p className="mt-3 text-base text-gray-600 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                Professional mobile detailing service with over 500 vehicles detailed and 50+ five-star reviews. 
                Experience premium care for your vehicle without leaving your home or office.
              </p>
              
              <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start gap-4">
                <Button 
                  onClick={scrollToContact}
                  size="lg"
                  className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white shadow-lg hover:shadow-xl transition-all text-lg px-8 py-6"
                >
                  Get Free Estimate
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
                <Button 
                  size="lg"
                  variant="outline"
                  className="w-full sm:w-auto mt-3 sm:mt-0 border-2 border-gray-300 hover:border-green-600 hover:text-green-600 transition-all text-lg px-8 py-6"
                  onClick={() => window.location.href = `tel:${businessInfo.phone}`}
                >
                  <Phone className="mr-2 h-5 w-5" />
                  {businessInfo.phone}
                </Button>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Hero Image */}
      <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
        <img
          className="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full"
          src="https://images.pexels.com/photos/6872609/pexels-photo-6872609.jpeg"
          alt="Professional car detailing"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/50 to-transparent lg:from-white/80"></div>
      </div>
    </div>
  );
};

export default Hero;
